import React from 'react';
import { CopyableBlock } from './CopyableBlock';

export const WhatsAppFormat = ({ data }) => {
  if (!data) return <p className="text-sm text-gray-500">No WhatsApp format available.</p>;

  // Supports rich seed shape AND fallback (.message).
  const shortText = data.short_text || data.message;
  const voiceNote = data.voice_note_script;
  const status = data.status_version;
  const quotes = data.shareable_quotes;
  const language = data.local_language_guidance;

  return (
    <div data-testid="whatsapp-format">
      <CopyableBlock label="Broadcast Text" content={shortText} testId="copy-wa-text" />
      <CopyableBlock label="Voice Note Script" content={voiceNote} testId="copy-wa-voice" />
      <CopyableBlock label="WhatsApp Status (1-line)" content={status} testId="copy-wa-status" />
      {Array.isArray(quotes) && quotes.length > 0 && (
        <CopyableBlock
          label="Shareable Quotes"
          content={quotes.map((q) => `“${q}”`).join('\n\n')}
          testId="copy-wa-quotes"
        />
      )}
      <CopyableBlock label="Local Language Guidance" content={language} testId="copy-wa-lang" />
    </div>
  );
};

export default WhatsAppFormat;
